module.exports = __webpack_public_path__ + "static/img/new-24-512.e8ef9ba1.png";